<template>
  <router-view />
</template>

<script>
import storeMixin, {
  unRegisterMixin,
} from '@quisit/mipe-utils/mixins/storeGenerator';

export default {
  name: 'WrapperCompuMeetingCoordination',
  mixins: [unRegisterMixin, storeMixin],
  data: () => ({
    moduleName: 'CompuMeetingCoordination',
  }),
};
</script>
